<template>
  <div class="component-view">
    <loader v-show="loading"></loader>
    <router-view class="view"></router-view>
  </div>
</template>

<script>
import Loader from './Loader.vue'
import { loading } from '../vuex/view/getters'

export default {
  components: {
    Loader
  },
  vuex: {
    getters: {
      loading
    }
  }
}
</script>

<style lang="scss">
.component-view {
  background-color: inherit;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// View.vue?0dfa9e25